
// frontend/geopolitikia/src/components/RightPanel.jsx
import React from 'react';
import {
  Shield,
  Swords,
  MapPin,
  User,
} from "lucide-react";
import Carte from "./Carte";
import Chat from "./Chat";

const RightPanel = ({ gameState, handleOpenPopin, setLoading, handleChat, setMessage, message, chatInputMessage, setChatInputMessage, chatStatus, pendingInvestments, mapActions, canValidate, setIsDragging, actionMessage, setActionMessage, redirect, gridData = null, turnSubmitted = false }) => {
  return (
    <div className="right-section">
      <div className="px-6 py-4 bg-slate-800/30 backdrop-blur-sm border-t border-slate-600">
        <div className="flex flex-wrap gap-4 text-sm">
          <div className="flex items-center gap-2">
            <Shield size={16} className="text-emerald-400" />
            <span className="text-emerald-300">Alliés</span>
          </div>
          <div className="flex items-center gap-2">
            <Swords size={16} className="text-red-400" />
            <span className="text-red-300">Ennemis</span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin size={16} className="text-slate-400" />
            <span className="text-slate-300">Neutres</span>
          </div>
          <div className="flex items-center gap-2">
            <User size={16} className="text-blue-400" />
            <span className="text-blue-300">Vous</span>
          </div>
          <div className="flex items-center gap-2">
            <span fontSize="14" textAnchor="middle" fill="#60a5fa">🏢</span>
            <span className="text-blue-300">Villes</span>
          </div>
          <div className="flex items-center gap-2">
            <span fontSize="14" textAnchor="middle" fill="#60a5fa">🔵</span>
            <span className="text-blue-300">Ressources importantes</span>
          </div>
        </div>
      </div>
      <main
        className={`custom-scrollbar bg-gradient-to-br from-slate-800 via-blue-500 to-blue-800 shadow-2xl border border-slate-700 overflow-hidden`}
      >
        <div>
            <Carte
              countries_dict={gameState.countries_dict}
              ocean={gameState?.climate?.ocean}
              onOpenPopin={handleOpenPopin}
              gridData={gridData}
              playerCountryId={gameState?.joueur?.id}
            />
        </div>
      </main>
      <Chat
        setLoading={setLoading}
        onChat={handleChat}
        setRetour={setMessage}
        backia={message}
        gameState={gameState}
        inputMessage={chatInputMessage}
        setInputMessage={setChatInputMessage}
        chatStatus={chatStatus}
        pendingInvestments={pendingInvestments}
        mapActions={mapActions}
        canValidate={canValidate}
        actionMessage={actionMessage}
        setActionMessage={setActionMessage}
        redirect={redirect}
        turnSubmitted={turnSubmitted}
      />
    </div>
  );
};

export default React.memo(RightPanel);
